module.exports = __webpack_public_path__ + "img/DFW_Arrow.a1a28cc4.png";